const PLATFORM_TOOLTIP_MAP: Record<string, string> = {
  evolution: 'Активно развивающаяся платформа для любых сценариев',
  advanced: '60+ IaaS- и PaaS-сервисов для развития инфраструктуры',
  mlspace: 'Суперкомпьютеры и ML для создания приложений',
  vmware: 'Облачная инфраструктура на базе технологий VMware',
};

export const getPlatformTooltip = (slug: string): string | undefined =>
  PLATFORM_TOOLTIP_MAP[slug];
